import { render, staticRenderFns } from "./stockTransfer.vue?vue&type=template&id=51869ee3&scoped=true"
import script from "./stockTransfer.vue?vue&type=script&lang=js"
export * from "./stockTransfer.vue?vue&type=script&lang=js"
import style0 from "./stockTransfer.vue?vue&type=style&index=0&id=51869ee3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51869ee3",
  null
  
)

export default component.exports